
/* styles */
require("!!vue-style-loader!happypack/loader?id=css!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-430230c1\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./richtext.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!happypack/loader?id=babel!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./richtext.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-430230c1\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./richtext.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/common/richtext/richtext.vue
// module id = 536
// module chunks = 23